module.exports = __webpack_public_path__ + "static/mr-concert-performance-11-778339f2e428be1a6cfd51081523a872.jpg";